import { Controller } from "react-hook-form"
import { Button } from "primereact/button"
import { FieldError } from "../../../../../../shared/FieldError"
import { InputText } from "primereact/inputtext"

export const ActionDepartment = ({ formState, i18n, onSubmit, loading }) => {
  const { t } = i18n

  const {
    handleSubmit,
    control,
    formState: { errors },
  } = formState

  return (
    <form onSubmit={handleSubmit((fData) => onSubmit(fData))}>
      <div className="form_fields_grid">
        <label className="align_self_center">{t("repeatedWords.nameOfObject")} *</label>
        <div className="form_input_container">
          <Controller
            name="name"
            control={control}
            rules={{ required: true }}
            render={({ field }) => (
              <InputText
                maxLength={50}
                placeholder={t("repeatedSentences.placeholder.nameOfObject")}
                value={field.value}
                onChange={(e) => field.onChange(e.target.value)}
              />
            )}
          />
          <FieldError fieldErr={errors?.name} />
        </div>

        <Button className="submit_button" label={t("repeatedWords.add")} {...(loading ? { loading } : {})} />
      </div>
    </form>
  )
}
